import { Theme } from '@/src/ct-design/token/theme'
import { CSSObject } from 'styled-components'
import { DotsColor, DotsColorType } from './type'

interface DotsStyleProps {
    theme: Theme
    variant?: 'dark' | 'light'
    size?: 'small' | 'medium' | 'large'
    speed?: 'slow' | 'normal' | 'fast'
    color?: DotsColorType
}

export const getDotsContainerStyles = (): CSSObject => {
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px'
    }
}

export const getDotsColor = (theme: Theme, color: DotsColorType) => {
    switch (color) {
        case DotsColor.PRIMARY: {
            return theme.color.text.primary
        }
        case DotsColor.SECONDARY: {
            return theme.color.text.secondary
        }
        case DotsColor.TERTIARY: {
            return theme.color.text.tertiary
        }
        case DotsColor.ALERT: {
            return theme.color.text.alert
        }
        case DotsColor.DISABLED: {
            return theme.color.text.disabled
        }
        case DotsColor.HEADING: {
            return theme.color.text.heading
        }
        case DotsColor.LINK: {
            return theme.color.text.link
        }
        case DotsColor.SUBHEADING: {
            return theme.color.text.subHeading
        }
        case DotsColor.SUCCESS: {
            return theme.color.text.success
        }
        case DotsColor.WARNING: {
            return theme.color.text.warning
        }
        case DotsColor.NEUTRAL: {
            return theme.color.text.neutral
        }
        default: {
            return theme.color.text.primary
        }
    }
}

export const getDotStyles = ({
    theme,
    variant = 'dark',
    size = 'medium',
    speed = 'normal',
    color
}: DotsStyleProps): CSSObject => {
    // Size mappings
    const sizeMap = {
        small: 6,
        medium: 8,
        large: 10
    }

    // Animation duration mappings
    const speedMap = {
        slow: 1.4,
        normal: 1,
        fast: 0.7
    }

    // Determine dot color

    let dotColor = ''
    if (color) {
        dotColor = getDotsColor(theme, color)
    }

    if (!dotColor) {
        if (variant === 'dark') {
            dotColor = theme.color.text.secondary
        } else {
            dotColor = theme.color.background.neutral
        }
    }

    return {
        width: `${sizeMap[size]}px`,
        height: `${sizeMap[size]}px`,
        backgroundColor: dotColor,
        borderRadius: '50%',
        display: 'inline-block',
        animation: `dotPulse ${speedMap[speed]}s infinite ease-in-out both`,

        '&.dot1': {
            animationDelay: '0s'
        },

        '&.dot2': {
            animationDelay: '0.2s'
        },

        '&.dot3': {
            animationDelay: '0.4s'
        }
    }
}

export const dotsKeyframes = `
@keyframes dotPulse {
    0%, 80%, 100% { 
        transform: scale(0);
        opacity: 0.5;
    }
    40% { 
        transform: scale(1);
        opacity: 1;
    }
}
`
